import { render, staticRenderFns } from "./Coefficients.vue?vue&type=template&id=2ad90f1c&"
import script from "./Coefficients.vue?vue&type=script&lang=js&"
export * from "./Coefficients.vue?vue&type=script&lang=js&"
import style0 from "./Coefficients.vue?vue&type=style&index=0&id=2ad90f1c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports